export default function EmptyFileUploadIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='41'
      height='40'
      viewBox='0 0 41 40'
      fill='none'
    >
      <g clipPath='url(#clip0_36_33364)'>
        <path
          d='M32.1667 8.33333V31.6667H8.83333V8.33333H32.1667ZM32.1667 5H8.83333C7 5 5.5 6.5 5.5 8.33333V31.6667C5.5 33.5 7 35 8.83333 35H32.1667C34 35 35.5 33.5 35.5 31.6667V8.33333C35.5 6.5 34 5 32.1667 5ZM24.0667 19.7667L19.0667 26.2167L15.5 21.9L10.5 28.3333H30.5L24.0667 19.7667Z'
          fill='#316CF4'
        />
      </g>
      <defs>
        <clipPath id='clip0_36_33364'>
          <rect
            width='40'
            height='40'
            fill='white'
            transform='translate(0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
